import * as React from 'react';
import { Grid } from '@mui/material';

import { EducationData, PersonalData, RegistrationData, VisitorData } from './FieldGroups';

export const GeneralTab: React.FC<{ hasEditPermission?: boolean }> = ({ hasEditPermission = false }) => (
    <Grid container columnSpacing={4} rowSpacing={1}>
        <EducationData hasEditPermission={hasEditPermission} />
        <PersonalData />
        <RegistrationData />
        <VisitorData />
    </Grid>
);

export default GeneralTab;
